import { useEffect, useState } from "react";

import size from "lodash/size";
import useAxios from "@src/utility/hooks/use-axios";
import { useParams } from "react-router-dom";

const useTickets = props => {
    const { attributes } = props;
    const { platformId } = useParams();
    const [tickets, setTickets] = useState({
        data     : [],
        active   : "",
        nextBatch: 0,
        count    : 0
    });
    const [ticketDetails, setTicketDetails] = useState({});
    const { axiosInstance, cancelAllRequests, loading } = useAxios({
        base         : "panel",
        initialLoader: true
    });

    const { axiosInstance: detailsInstance, loading: detailsLoading } =
        useAxios({ base: "panel" });

    const getTicketDetails = async activeTicket => {
        if (!detailsLoading) {
            setTickets(prev => ({
                ...prev,
                active: activeTicket
            }));
            const { data } = await detailsInstance.get(
                `/support/ticket/${activeTicket}`,
                {
                    params: {
                        platform: attributes.platform._id
                    }
                }
            );
            setTicketDetails(data);
        }
    };

    const getTickets = async () => {
        const { data } = await axiosInstance.get(
            `/support/${platformId}/tickets/${attributes._id}?batch=${tickets.nextBatch}`
        );

        if (data.tickets) {
            setTickets((prevState) => ({
                nextBatch: data.nextBatch,
                data     : Array.from(
                    new Map([...prevState.data, ...data.tickets].map(item => [item.id, item])).values()
                ),
                active: size(prevState.data) === 0 ? data.tickets?.[0]?.id : prevState.active,
                count : data.count
            }));

            if (size(tickets.data) === 0 && size(data.tickets)) {
                getTicketDetails(data.tickets?.[0]?.id);
            }
        }
    };

    useEffect(() => {
        let isActive = true;
        if (isActive && size(attributes)) {
            getTickets();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [attributes]);

    return {
        loading,
        tickets,
        ticketDetails,
        getTicketDetails,
        detailsLoading,
        getTickets
    };
};

export default useTickets;